// extracted by mini-css-extract-plugin
export default {"fade-in":"PageContainer_fade-in__iDDGB"};